<template>
    <div class="w-full flex flex-col items-start justify-start gap-6 px-4 lg:px-48 pb-5 lg:pb-10">
        <div class="bg-white rounded-xl shadow-md flex flex-col items-start text-gray-800 w-full">
            <p class="px-6 py-2 font-medium text-base text-white lg:text-lg bg-primary w-full mt-5 lg:mt-10">
                Confirm Submission
            </p>

            <div class="p-3 lg:p-6 w-full text-gray-600">
                <!-- Display each registrant -->
                <div v-for="(registrant, index) in registrants" :key="index"
                    class="border-b border-gray-200 pb-6 mb-6 last:border-none last:pb-0 last:mb-0">
                    <!-- Header with Edit Button and Collapse Toggle -->
                    <div class="flex flex-col mb-5 text-sm lg:text-base cursor-pointer select-none bg-gray-100 p-2 lg:p-4 rounded-md"
                        @click="toggleCollapse(index)">
                        <div class="flex justify-between items-center">
                            <!-- Left side -->
                            <div class="flex flex-col">
                                <div class="flex items-center space-x-2">
                                    <p class="font-semibold text-primary">Registrant #{{ index + 1 }}</p>
                                    <img :class="['w-4 h-4 transform', registrant.collapsed ? 'rotate-0' : 'rotate-180']"
                                        src='@/assets/icons/collapse_icon.svg' alt="toggle" />
                                </div>
                                <!-- Show full name only when collapsed -->
                                <p v-if="registrant.collapsed && (registrant.fname || registrant.lname)"
                                    class="text-gray-500 text-sm lg:text-base mt-1 uppercase">
                                    {{ registrant.fname || '' }} {{ registrant.lname || '' }} |
                                    {{optionsCategory.find(option => option.value === registrant.category)?.label
                                    || registrant.category }}
                                    <span v-if="registrant.distance">({{ getDistanceLabel(registrant) }})</span>
                                </p>
                            </div>

                            <!-- Edit button -->
                            <button @click.stop="editRegistrant(index)"
                                class="flex items-center text-primary text-sm lg:text-base hover:underline font-medium">
                                <img src="@/assets/icons/edit_icon.svg" alt="edit" class="w-4 h-4 mr-1" />
                                Edit
                            </button>
                        </div>
                    </div>





                    <!-- Collapsible content -->
                    <transition name="slide-fade">
                        <div v-if="!registrant.collapsed" class="form-grid w-full mt-2 lg:mt-3">
                            <TextControl label="Full Name" fieldId="fname" v-model="registrant.fname"
                                :disabled="true" />
                            <TextControl label="Middle Name" fieldId="mname" v-model="registrant.mname"
                                :disabled="true" />
                            <TextControl label="Last Name" fieldId="lname" v-model="registrant.lname"
                                :disabled="true" />
                            <TextControl label="Email Address" fieldId="email" v-model="registrant.email"
                                :disabled="true" />
                            <TextControl label="Mobile Number" fieldId="mobile" v-model="registrant.mobile"
                                :disabled="true" />

                            <div class="form-grid">
                                <TextControl label="Age" fieldId="age" v-model="registrant.age" :disabled="true" />
                                <ComboBoxControl label="Gender" fieldId="gender" :options="optionsGender"
                                    v-model="registrant.gender" :disabled="true" />
                            </div>

                            <div class="form-grid">
                                <ComboBoxControl label="Segment" fieldId="segment" :options="optionsSegment"
                                    v-model="registrant.segment" :disabled="true" />
                                <ComboBoxControl v-if="registrant.segment === 'SPR'" label="Sponsor Type"
                                    fieldId="sponsor_type" :options="optionsSponsorType"
                                    v-model="registrant.sponsor_type" :disabled="true" />

                                <ComboBoxControl v-else-if="['MEM', 'EMP', 'DEP', 'NON', 'NDP'].includes(registrant.segment)"
                                    label="Branch Service" fieldId="branch_service"
                                    :options="getBranchOptions(registrant.segment)" v-model="registrant.branch_service"
                                    :disabled="true" />

                            </div>

                            <div class="form-grid">

                                <TextControl label="Account Number" fieldId="account_no" v-model="registrant.account_no"
                                    :disabled="true" />
                                <!-- Add Serial Number -->
                                <TextControl label="Serial Number" fieldId="serial_no" v-model="registrant.serial_no"
                                    :disabled="true" />
                            </div>

                            <ComboBoxControl label="Select Event Category" fieldId="category" :options="optionsCategory"
                                v-model="registrant.category" :disabled="true" />
                            <ComboBoxControl label="Choose Race Distance" fieldId="distance"
                                :options="getDistanceOptions(registrant.segment)" v-model="registrant.distance"
                                :disabled="true" />
                        </div>
                    </transition>
                </div>

                <!-- Buttons -->
                <div class="w-full flex justify-end mt-10">
                    <div class="w-full flex flex-row lg:w-1/3 space-x-3">
                        <ButtonControl variant="secondary" @click="$router.back()"> BACK </ButtonControl>
                        <ButtonControl variant="primary" @click="confirm_modal = true"> SUBMIT </ButtonControl>
                    </div>
                </div>
            </div>
        </div>

        <!-- Confirm Modal -->
        <transition name="slide-in">
            <MessageBoxControl v-if="confirm_modal" :is_visible="confirm_modal" :positiveButton="'Yes'"
                @positiveClick="submitForm" :negativeButton="'No'" @negativeClick="confirm_modal = false"
                :theme="'warning'" :title="'Confirm'" :message="'Are you sure you want to submit?'" />
        </transition>

        <!-- Message Modal -->
        <transition name="slide-in">
            <MessageBoxControl v-if="message_modal" :is_visible="message_modal" :positiveButton="btn_text"
                @positiveClick="handlePositiveClick" :theme="theme" :title="title" :message="message" />
        </transition>
    </div>
</template>

<script>
import ButtonControl from "@/components/controls/ButtonControl.vue";
import MessageBoxControl from "@/components/controls/MessageBoxControl.vue";
import TextControl from "@/components/controls/TextControl.vue";
import ComboBoxControl from "@/components/controls/ComboBoxControl.vue";
import user from "@/services/user";
import confirmLeave from "@/mixins/confirmLeave";

export default {
    name: "ConfirmView",
    inject: ["setLoading"],
    mixins: [confirmLeave],
    components: {
        ButtonControl,
        MessageBoxControl,
        TextControl,
        ComboBoxControl,
    },
    data() {
        return {
            uuid: null,
            confirm_modal: false,
            message_modal: false,
            registrants: [],
            theme: null,
            title: null,
            message: null,
            btn_text: null,
            optionsGender: [
                { value: "M", label: "Male" },
                { value: "F", label: "Female" },
                { value: "X", label: "Rather not say" },
            ],
            optionsSegment: [],
            optionsSponsorType: [
                { value: "P", label: "PLATINUM" },
                { value: "G", label: "GOLD" },
                { value: "S", label: "SILVER" },
                { value: "B", label: "BRONZE" },
            ],
            branchOptions: {
                MEM: [
                    { value: "PA", label: "PHILIPPINE ARMY" },
                    { value: "PN", label: "PHILIPPINE NAVY" },
                    { value: "PAF", label: "PHILIPPINE AIR FORCE" },
                    { value: "RET", label: "RETIREE" },
                    { value: "DEP", label: "DEPENDENT" },
                    { value: "CE", label: "CIVILIAN EMPLOYEE" },
                ],
                EMP: [
                    { value: "HO", label: "MAIN OFFICE" },
                    { value: "PSO", label: "PSO" },
                ],
            },
            optionsCategory: [
                { value: "1", label: "FUN RUN" },
                { value: "2", label: "ZUMBA" },
                { value: "3", label: "BOTH FUN RUN AND ZUMBA" },
            ],
        };
    },
    mounted() {
        if (this.$store.state.segment && Array.isArray(this.$store.state.segment)) {
            this.optionsSegment = this.$store.state.segment;
        }

        if (this.$store.state.form && Array.isArray(this.$store.state.form)) {
            this.registrants = JSON.parse(JSON.stringify(this.$store.state.form)).map((r) => ({
                ...r,
                collapsed: false, // 👈 add collapsed state
            }));
        }

        if (this.$store.state.uuid) {
            this.uuid = this.$store.state.uuid;
            console.log("Loaded UUID:", this.uuid);
        }

        if (!this.$store.state.form) {
            this.$router.push("/");
        }
    },
    methods: {
        getDistanceLabel(registrant) {
            if (!registrant.segment || !registrant.distance || !this.$store.state.distance) return "";

            const distanceObj = this.$store.state.distance.find(d => d[registrant.segment]);
            if (!distanceObj) return "";

            const distanceOption = distanceObj[registrant.segment].find(d => d.value === registrant.distance);
            return distanceOption ? distanceOption.label : registrant.distance;
        },
        getBranchOptions(segment) {
            if (!segment) return [];
            return segment === "MEM" ? this.branchOptions.MEM : this.branchOptions.EMP;
        },
        toggleCollapse(index) {
            this.registrants[index].collapsed = !this.registrants[index].collapsed;
        },
        getDistanceOptions(segment) {
            if (!segment || !this.$store.state.distance) return [];
            const distanceObj = this.$store.state.distance.find((d) => d[segment]);
            if (!distanceObj) return [];
            return distanceObj[segment].map((item) => ({
                value: item.value,
                label: item.slot ? item.label : `${item.label} - NO SLOT AVAILABLE`,
                disabled: !item.slot,
            }));
        },
        handlePositiveClick() {
            if (this.theme === "success" || this.theme === "info") {
                this.$router.push("/");
            } else {
                this.message_modal = false;
            }
        },
        editRegistrant(index) {
            this.$store.state.editIndex = index;
            this.$store.state.fromConfirm = true;
            this.$router.push("/registration");
        },
        submitForm() {
            this.setLoading(true);
            this.confirm_modal = false;

            const registrantsPayload = this.registrants.map((r) => ({
                account_no: r.account_no,
                age: r.age,
                branch_service: r.branch_service,
                category: r.category,
                distance: r.distance,
                email: r.email,
                fname: r.fname,
                gender: r.gender,
                lname: r.lname,
                mname: r.mname,
                mobile: r.mobile,
                segment: r.segment,
                serial_no: r.serial_no,
                sponsor_type: r.sponsor_type,
                date_signed: r.waiverData?.date_signed || null,
                guardian_name: r.waiverData?.guardian_name || null,
                relationship: r.waiverData?.relationship || null,
            }));

            user
                .register(registrantsPayload, this.uuid)
                .then((response) => {
                    this.$store.state.email = response.data.data;
                    this.message_modal = true;
                    this.message =
                        "We’ve received your registration for PAPSI RUN: FortyFOURWARDofHOPE. Please note that your registration is still being processed and does not guarantee a slot yet. Kindly wait for the confirmation email with your QR code, which will be sent to your provided email address.";
                    this.theme = "success";
                    this.title = "Submitted";
                    this.btn_text = "OK";
                })
                .catch((error) => {
                    this.message_modal = true;
                    this.theme = error.response?.data?.status === 409 ? "info" : "error";
                    this.title = this.theme === "info" ? "Information" : "Error";
                    this.message = error.response?.data?.message || "Something went wrong";
                    this.btn_text = "Ok";
                })
                .finally(() => {
                    this.setLoading(false);
                });
        }
    },
};
</script>

<style scoped>
.material-icons {
    font-size: 18px;
    vertical-align: middle;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1.25rem;
    /* gap-5 */
}

@media (min-width: 1024px) {
    .form-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

.col-span-full-lg {
    grid-column: span 1 / span 1;
    /* default for small screens */
}

@media (min-width: 1024px) {
    .col-span-full-lg {
        grid-column: span 2 / span 2;
        /* span 2 columns on lg+ screens */
    }
}
</style>
